export default "__VITE_ASSET__40c7a3ad__"